<template>
  <wine-limits-component />
</template>

<script>
import WineLimitsComponent from "@/spa/components/board/wine/limits/BoardLimits";

export default {
  name: "LimitsPage",
  components: {
    WineLimitsComponent
  }
};
</script>



// WEBPACK FOOTER //
// src/spa/pages/contents/wine/LimitsPage.vue